import { Box, Button, Typography, Divider } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import { jewlr_t } from "helpers/application"

import Demo from "./demo"
import HowItWorks from "./how-it-works"

const CTA = styled(Button).attrs({
  borderRadius: "5px",
  fontSize: "18px",
  height: "48px",
  letterSpacing: "0.5px",
  lineHeight: "16px",
  variant: "primary",
  width: { _: "100%", tablet: "auto" },
})``

const ExplainedModal = ({ action, inCart, inModal }) => {
  return (
    <Box containWide mb={{ _: 2, tablet: 5 }}>
      <Box mb={{ _: 4, tablet: "60px" }} textAlign="center">
        <Typography
          className="nowrap"
          fontSize="18px"
          mb="10px"
          pb={6}
          variant="body"
        >
          Order Today, Share Right Away!
        </Typography>
        <HowItWorks inModal />
        <Divider bg="grey.10" mb={2} mt={{ _: 4, tablet: "60px" }} />
        <Typography
          mb={{ _: "10px", tablet: "12px" }}
          pt={{ tablet: "6px" }}
          variant="h3"
        >
          {inCart ? (
            `${jewlr_t("terms.Personalize")} Your Gift Preview Video`
          ) : (
            <>What They Get</>
          )}
        </Typography>
        <Typography
          fontSize="16px"
          mx="auto"
          variant="body"
          width={{ _: "100%", tablet: "325px" }}
        >
          Your video includes a preview of your custom gift and a personal
          message.
        </Typography>
        {inCart && (
          <CTA mt={{ _: "10px", tablet: 3 }} onClick={() => action()}>
            Create Now!
          </CTA>
        )}
        <Box textAlign="left">
          <Demo inModal={inModal} />
        </Box>
        {inCart && (
          <CTA mt={{ _: "10px", tablet: 3 }} onClick={() => action()}>
            Create Now!
          </CTA>
        )}
      </Box>
    </Box>
  )
}

ExplainedModal.propTypes = {
  action: PropTypes.func,
  inCart: PropTypes.bool,
  inModal: PropTypes.bool,
}

export default ExplainedModal
